import React from 'react';

import {EMPTY_SEARCH_RESULT_PROPS} from 'notebook/mediocre/search/SearchResultProps';

import {TooltipIcon} from '../TableConstants';
import TableAxisCell, {AxisType} from './TableAxisCell';

export interface SimpleTableAxisCellProps {
  index: number;
  // Should be either 'column' or 'row'
  dim: AxisType;
  iconPrefix?: string;
  label: string;
  // The number of rows or columns that are present
  numDims: number;
  isGhostCell?: boolean;
  tooltipIcons?: Array<TooltipIcon>;
  isLeftAlign?: boolean;
}

/**
 * A simple TableAxisCell that does not have a ColumnConstraint.
 */
function SimpleTableAxisCell(props: SimpleTableAxisCellProps): JSX.Element {
  return (
    <TableAxisCell
      index={props.index}
      shouldHighlightCell={false}
      allowEmpty={false}
      allowNoRows={false}
      dim={props.dim}
      disableFormulas={true}
      disallowCustomColumns={false}
      isGhostCell={false}
      isHeaderCell={true}
      isLeftAlign={props.isLeftAlign}
      isSelected={false}
      label={props.label}
      renderedLabel={props.label}
      numDims={props.numDims}
      shouldDisableDeleteDim={true}
      shouldDisableInsertDimAfter={true}
      shouldDisableInsertDimBefore={true}
      showExcessLabels={false}
      tooltipIcons={props.tooltipIcons}
      {...EMPTY_SEARCH_RESULT_PROPS}
    />
  );
}

SimpleTableAxisCell.defaultProps = {
  isGhostCell: false,
  isLeftAlign: true,
};

export default SimpleTableAxisCell;
